import React, {useCallback, useEffect, useState} from 'react'
import Sidebar from '../components/Sidebar'
import Header from '../components/Header'
import CoverInput from '../components/Content/CoverInput'
import TitleInput from '../components/Content/TitleInput'
import DescInput from '../components/Content/DescInput'
import TopicInput from '../components/Content/TopicInput'
import DocsInput from '../components/Content/DocsInput'
import VideoLinkInput from '../components/Content/VideoLinkInput'
import QuizzesInput from '../components/Content/QuizzesInput'
import QuizModal from '../components/Content/QuizModal'
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'
import { authenticated } from '../recoil/auth'
import { contentInput, contentLoading, contentMessage } from '../recoil/content'
import { domainWeb } from '../config/constants'
import axios from 'axios'
import WaitingText from '../components/WaitingText'
import { quizDetail } from '../recoil/quiz'

const ContentAddPage = () => {
    const auth = useRecoilValue(authenticated);
    const [loading, setLoading] = useRecoilState(contentLoading);
    const [input, setInput] = useRecoilState(contentInput);
    const [message, setMessage] = useRecoilState(contentMessage);
    const [showQuizModal, setShowQuizModal] = useState(false);
    const setQuizSelected = useSetRecoilState(quizDetail);

    const middleLink = {
        label: "Konten",
        route: "/contents"
    };

    const resetInput = useCallback(() => {
        setInput({
            cover: null,
            title: '',
            description: '',
            topic: '',
            documents: [],
            videos: [],
            quizzes: [],
        });
    }, [setInput]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage({});
        
        let url = `${domainWeb}/contents`;
        let validation = validationInput();
        if (validation.success) {
            const formData = new FormData();
            formData.append("cover", input.cover);
            formData.append("title", input.title);
            formData.append("description", input.description);
            formData.append("topic", input.topic);
            input.documents.forEach(doc => {
                formData.append("documents", doc);
            });
            formData.append("videos", JSON.stringify(input.videos));
            formData.append("quizzes", JSON.stringify(input.quizzes));

            await axios.post(url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': 'Bearer ' + auth.token
                }
            }).then(() => {
                setMessage({
                    success: true,
                    text: 'Berhasil Tambah Konten',
                });
                resetInput();
            }).catch((error) => {
                console.error(error);
            });
            setLoading(false)
        } else {
            setMessage(validation);
            setLoading(false);
        }
        
    };

    const validationInput = () => {
        if (input.cover === null) {
            return {
                success: false,
                text: 'Cover tidak boleh kosong!',
            };
        }
        if (input.title === '') {
            return {
                success: false,
                text: 'Judul Konten tidak boleh kosong!',
            };
        }
        if (input.description === '') {
            return {
                success: false,
                text: 'Deskripsi tidak boleh kosong!',
            };
        }
        if (input.topic === '') {
            return {
                success: false,
                text: 'Topik belum dipilih!',
            };
        }
        if (input.documents.length === 0) {
            return {
                success: false,
                text: 'Dokumen tidak boleh kosong!',
            }
        }
        if (input.quizzes.length === 0) {
            return {
                success: false,
                text: 'Soal kuis tidak boleh kosong!',
            }
        }
        return {
            success: true,
            text: ''
        };
    }

    const clickQuiz = (quiz) => {
        setQuizSelected(quiz);
        setShowQuizModal(true);
    }

    const closeQuiz = () => {
        setQuizSelected({});
        setShowQuizModal(false);
    }

    const loadMessage = () => {
        if (message.success) {
          return <div className="mt-3 text-green-500">{message.text}</div>;
        } else {
          return <div className="mt-3 text-red-500">{message.text}</div>;
        }
    }

    useEffect(() => {
        document.title = 'Tambah Konten - Admin Hi Nano';
        resetInput();
    }, [resetInput]);

    return (
        <div className="flex min-h-screen bg-slate-100">
            <Sidebar />
            <div className="flex-1 p-10 ml-28">
                <Header title="Tambah Konten" middle={middleLink} />
                <div className="px-8 py-5 bg-white rounded-lg shadow">
                    <h3 className="text-xl font-semibold">Form Konten</h3>
                    {message.text === undefined || loadMessage()}
                    <form onSubmit={handleSubmit}>
                        <div className="flex gap-10 mt-5">
                            <CoverInput />
                            <div className="flex flex-col flex-1 gap-8">
                                <TitleInput />
                                <DescInput />
                                <TopicInput />
                                <DocsInput />
                                <VideoLinkInput />
                                <QuizzesInput clickQuiz={clickQuiz} />
                                <div className="my-3">
                                    {
                                        loading
                                        ? <button type="button" className="gap-3 px-5 py-3 text-center text-white bg-blue-600 rounded-lg shadow hover:bg-blue-700 shadow-blue-100">
                                                <WaitingText />
                                            </button>
                                        : <button type="submit" className="gap-3 px-5 py-3 text-center text-white bg-blue-600 rounded-lg shadow hover:bg-blue-700 shadow-blue-100">
                                                <span>Tambah Konten</span>
                                            </button>
                                    }
                                    
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            {
                showQuizModal ? (
                    <QuizModal closeQuiz={closeQuiz} />
                ) : ("")
            }
            
        </div>
    )
}

export default ContentAddPage